import {
  Button,
  Divider,
  Grid,
  Paper,
  Tab,
  TextField as MuiTextField,
  Tabs,
  Typography,
} from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { isEqual } from 'lodash'
import { memo, useCallback, useState } from 'react'
import { metodoPrograma } from '../../../components/api'
import { setError, setSuccess } from '../../../components/alerts'
import * as Yup from 'yup'
import CurrencyField from '../../../components/CurrencyField/CurrencyField'
import PrimeTable from '../../../components/PrimeTable'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import PercentField from '../../../components/PercentField/PercentField'

const retornaTpAtendimento = (u = []) => ({
  idTipoAtendimento: u?.[0] || undefined,
  dsNome: u?.[1] || undefined,
  dsAtendimento: u?.[2] || undefined,
  vlAtendimento: u?.[3] || undefined,
  dtInclusao: u?.[4] || undefined,
  dtExclusao: u?.[5] || undefined,
})

const validationSchema = Yup.object({
  dsNome: Yup.string().required('Campo Obrigatório!'),
  dsAtendimento: Yup.string().required('Campo Obrigatório!'),
})

const Edicao = ({ dados, voltar }) => {
  const [refresh, setRefresh] = useState(0)
  const [tab, setTab] = useState(0)
  const salva = async (values) => {
    const res = await metodoPrograma('salva', values)
    if (res.status) {
      voltar()
    } else {
      setError(res.dsErro)
    }
  }

  const exclui = useCallback((dadosAtendimento) => {
    metodoPrograma('excluiTipoAtendimentoUsuario', {
      idUsuario: dadosAtendimento[0][0][0],
      idTipoAtendimento: dadosAtendimento[1][0][0],
    }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  const salvaTipoAtendimentoUsuario = async (values, close) => {
    const payload = {
      idUsuario: values?.acUsuario?.[0]?.[0],
      idTipoAtendimento: dados[0],
      vlComissao: values?.vlComissao || null,
      qtParcelas: values?.prComissao || null,
    }

    const resp = await metodoPrograma('salvaTipoAtendimentoUsuario', payload)
    if (resp.status) {
      setSuccess('Registro inserido!')
      setRefresh((prev) => prev + 1)
      close()
    }
  }

  const editarTipoAtendimentoUsuario = async (linha, close) => {
    const payload = {
      idUsuario: linha?.[0][0][0],
      idTipoAtendimento: linha[1][0][0],
      vlComissao: linha?.[2] || null,
      prComissao: linha?.[3] || null,
    }
    const resp = await metodoPrograma('salvaTipoAtendimentoUsuario', payload)

    if (resp.status) {
      setSuccess('Registro alterado!')
      setRefresh((prev) => prev + 1)
      close()
    }
  }

  const excluiTerapiaTipoAtendimento = useCallback((linha) => {
    metodoPrograma('excluiTerapiaTipoAtendimento', {
      idTipoAtendimento: linha[0],
      idTerapia: linha[1][0][0],
    }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  const salvaTerapiaTipoAtendimento = async (values, close) => {
    const resp = await metodoPrograma('salvaTerapiaTipoAtendimento', {
      idTipoAtendimento: dados[0],
      idTerapia: values?.acTerapia?.[0]?.[0],
      qtTerapia: Number(values?.qtTerapia),
    })

    if (resp.status) {
      setSuccess('Terapia inserida!')
      setRefresh((prev) => prev + 1)
      close()
    } else {
      setError(resp.dsErro)
    }
  }

  const editaTerapiaTipoAtendimento = async (linha, close) => {
    const resp = await metodoPrograma('salvaTerapiaTipoAtendimento', {
      idTipoAtendimento: linha[0],
      idTerapia: linha[1][0][0],
      qtTerapia: Number(linha[2]),
    })

    if (resp.status) {
      setSuccess('Terapia alterada!')
      setRefresh((prev) => prev + 1)
      close()
    } else {
      setError(resp.dsErro)
    }
  }

  return (
    <Formik
      initialValues={retornaTpAtendimento(dados)}
      validationSchema={validationSchema}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm, setFieldValue }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Field
                component={TextField}
                name="dsNome"
                label="Nome"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                component={TextField}
                rows={4}
                multiline
                name="dsAtendimento"
                label="Atendimento"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
              <Field
                component={TextField}
                name="dtInclusao"
                label="Inclusão"
                fullWidth
                disabled
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
              <Field
                component={TextField}
                name="dtExclusao"
                label="Exclusão"
                fullWidth
                disabled
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
              <CurrencyField
                fullWidth
                value={dados?.[3]}
                variant="outlined"
                margin="dense"
                label="Valor"
                size="small"
                onChange={(v) => {
                  setFieldValue('vlAtendimento', v)
                }}
              />
            </Grid>
            {dados?.[0] !== undefined && (
              <Grid item xs={12}>
                <Tabs
                  value={tab}
                  onChange={(_, value) => setTab(value)}
                  textColor="primary"
                  indicatorColor="primary"
                >
                  <Tab value={0} label="Terapias do Pacote" />
                  <Tab value={1} label="Vendedores e Comissões" />
                </Tabs>
              </Grid>
            )}
            {dados?.[0] !== undefined && tab === 0 && (
              <Grid item xs={12}>
                <Paper
                  elevation={2}
                  style={{
                    backgroundColor: '#f5f5f5',
                    borderRadius: '12px',
                    padding: '20px',
                    marginTop: '16px',
                  }}
                >
                  <Typography variant="h6" style={{ fontWeight: 300 }}>
                    Terapias do Pacote
                  </Typography>
                  <Divider />
                  <PrimeTable
                    codigo="CtrlTipoAtendimento"
                    action="listaTerapiaTipoAtendimento"
                    parametros={{ idTipoAtendimento: dados[0] }}
                    rows={10}
                    editButton
                    addButton
                    fastDisablePortal={false}
                    fastAddComponent={({ values, edit, close }) => (
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={8}>
                          <AutoComplete
                            InputLabelProps={{ shrink: true }}
                            label="Terapia"
                            metodo="buscaTerapia"
                            value={values?.acTerapia ?? []}
                            fullWidth
                            margin="dense"
                            variant="outlined"
                            size="small"
                            onChange={(_, val) =>
                              edit({ value: val, field: 'acTerapia' })
                            }
                            textFieldProps={{
                              helperText: !values?.acTerapia
                                ? 'Campo Obrigatório!'
                                : '',
                              error: !values?.acTerapia,
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <MuiTextField
                            fullWidth
                            label="Quantidade"
                            type="number"
                            inputProps={{ min: 1, step: 1 }}
                            margin="dense"
                            variant="outlined"
                            size="small"
                            value={values?.qtTerapia ?? ''}
                            onChange={(event) =>
                              edit({
                                value: event.target.value,
                                field: 'qtTerapia',
                              })
                            }
                            error={!values?.qtTerapia}
                            helperText={
                              !values?.qtTerapia ? 'Campo Obrigatório!' : ''
                            }
                          />
                        </Grid>
                        <Grid
                          item
                          container
                          xs={12}
                          spacing={2}
                          justifyContent="flex-end"
                        >
                          <Grid item xs={12} md={2}>
                            <Button
                              onClick={close}
                              fullWidth
                              variant="contained"
                              color="inherit"
                              style={{ margin: '5px' }}
                            >
                              Cancelar
                            </Button>
                          </Grid>
                          <Grid item xs={12} md={2}>
                            <Button
                              onClick={() =>
                                !!values?.acTerapia &&
                                Number(values?.qtTerapia) > 0 &&
                                salvaTerapiaTipoAtendimento(values, close)
                              }
                              variant="contained"
                              fullWidth
                              color="primary"
                              style={{ margin: '5px' }}
                            >
                              Salvar
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                    fastEditComponent={({ linha, close, edit }) => (
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={8}>
                          <AutoComplete
                            InputLabelProps={{ shrink: true }}
                            label="Terapia"
                            metodo="buscaTerapia"
                            value={linha?.[1]}
                            fullWidth
                            disabled
                            margin="dense"
                            variant="outlined"
                            size="small"
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <MuiTextField
                            fullWidth
                            label="Quantidade"
                            type="number"
                            inputProps={{ min: 1, step: 1 }}
                            margin="dense"
                            variant="outlined"
                            size="small"
                            value={linha?.[2] ?? ''}
                            onChange={(event) =>
                              edit({ value: event.target.value, index: 2 })
                            }
                            error={!linha?.[2]}
                            helperText={!linha?.[2] ? 'Campo Obrigatório!' : ''}
                          />
                        </Grid>
                        <Grid
                          item
                          container
                          xs={12}
                          spacing={2}
                          justifyContent="flex-end"
                        >
                          <Grid item xs={12} md={2}>
                            <Button
                              onClick={close}
                              fullWidth
                              variant="contained"
                              color="inherit"
                              style={{ margin: '5px' }}
                            >
                              Cancelar
                            </Button>
                          </Grid>
                          <Grid item xs={12} md={2}>
                            <Button
                              onClick={() =>
                                Number(linha?.[2]) > 0 &&
                                editaTerapiaTipoAtendimento(linha, close)
                              }
                              variant="contained"
                              fullWidth
                              color="primary"
                              style={{ margin: '5px' }}
                            >
                              Salvar
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                    head={['Terapia', 'Quantidade']}
                    colStyle={[{ width: '75%' }, { width: '25%' }]}
                    line={(item) => [item[1][1], item[2]]}
                    onDelete={{
                      index: 3,
                      action: excluiTerapiaTipoAtendimento,
                    }}
                    refresh={refresh}
                  />
                </Paper>
              </Grid>
            )}
            {dados?.[0] !== undefined && tab === 1 && (
              <Grid item xs={12}>
                <Paper
                  elevation={2}
                  style={{
                    backgroundColor: '#f5f5f5',
                    borderRadius: '12px',
                    padding: '20px',
                    marginTop: '16px',
                  }}
                >
                  <Typography variant="h6" style={{ fontWeight: 300 }}>
                    Vendedores e Comissões
                  </Typography>
                  <Divider />
                  <PrimeTable
                    codigo="CtrlTipoAtendimento"
                    action="listaTipoAtendimentoUsuario"
                    parametros={{ idTipoAtendimento: dados[0] }}
                    rows={10}
                    editButton
                    addButton
                    fastAddComponent={({ values, edit, close }) => (
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                          <AutoComplete
                            InputLabelProps={{ shrink: true }}
                            label="Vendedor"
                            metodo="buscaUsuario"
                            getOptionLabel={(v) => v?.[1] || ''}
                            value={values?.acUsuario ?? []}
                            fullWidth
                            margin="dense"
                            variant="outlined"
                            size="small"
                            onChange={async (_, val) => {
                              await edit({
                                value: val,
                                field: 'acUsuario',
                              })
                              await edit({
                                value: val[0][0] || 0,
                                field: 'idUsuario',
                              })
                            }}
                            textFieldProps={{
                              helperText: !values?.acUsuario
                                ? 'Campo Obrigatório!'
                                : '',
                              error: !values?.acUsuario,
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <CurrencyField
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            name="vlComissao"
                            label="Valor por Venda"
                            size="small"
                            value={values?.vlComissao}
                            onChange={(v) =>
                              edit({ value: v, field: 'vlComissao' })
                            }
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <PercentField
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            name="prComissao"
                            label="Percentual por Venda"
                            size="small"
                            value={values?.prComissao}
                            onChange={(v) =>
                              edit({ value: v, field: 'prComissao' })
                            }
                          />
                        </Grid>

                        <Grid
                          item
                          container
                          xs={12}
                          spacing={2}
                          justifyContent="flex-end"
                        >
                          <Grid item xs={12} md={2}>
                            <Button
                              onClick={close}
                              fullWidth
                              variant="contained"
                              color="inherit"
                              style={{ margin: '5px' }}
                            >
                              Cancelar
                            </Button>
                          </Grid>
                          <Grid item xs={12} md={2}>
                            <Button
                              onClick={() =>
                                !!values?.idUsuario &&
                                salvaTipoAtendimentoUsuario(values, close)
                              }
                              variant="contained"
                              fullWidth
                              color="primary"
                              style={{ margin: '5px' }}
                            >
                              Salvar
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                    fastEditComponent={({ linha, close, edit }) => (
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                          <AutoComplete
                            InputLabelProps={{ shrink: true }}
                            metodo="buscaUsuario"
                            label="Vendedor"
                            getOptionLabel={(v) => v?.[1] || ''}
                            value={linha?.[0]}
                            name="acUsuario"
                            fullWidth
                            margin="dense"
                            variant="outlined"
                            size="small"
                            onChange={async (_, val) => {
                              await edit({ value: val?.[2] || 0, index: 0 })
                            }}
                            textFieldProps={{
                              helperText: !linha?.[0]
                                ? 'Campo Obrigatório!'
                                : '',
                              error: !linha?.[0],
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <CurrencyField
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            label="Valor por Venda"
                            size="small"
                            value={linha?.[2]}
                            onChange={(v) => edit({ value: v, index: 2 })}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <PercentField
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            label="Percentual Venda"
                            size="small"
                            value={linha?.[3]}
                            onChange={(v) => edit({ value: v, index: 3 })}
                          />
                        </Grid>
                        <Grid
                          item
                          container
                          xs={12}
                          spacing={2}
                          justifyContent="flex-end"
                        >
                          <Grid item xs={12} md={2}>
                            <Button
                              onClick={close}
                              fullWidth
                              variant="contained"
                              color="inherit"
                              style={{ margin: '5px' }}
                            >
                              Cancelar
                            </Button>
                          </Grid>
                          <Grid item xs={12} md={2}>
                            <Button
                              onClick={() =>
                                !!linha?.[0] &&
                                editarTipoAtendimentoUsuario(linha, close)
                              }
                              variant="contained"
                              fullWidth
                              color="primary"
                              style={{ margin: '5px' }}
                            >
                              Editar
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                    head={[
                      'Vendedor',
                      'Valor por Venda',
                      'Percentual por Venda',
                    ]}
                    colStyle={[
                      { width: '60%' },
                      { width: '20%' },
                      { width: '20%' },
                    ]}
                    line={(item) => [item[0][1], item[2], item[3]]}
                    collumnsCurrency={[1]}
                    collumnsPercent={[2]}
                    onDelete={{ index: 5, action: exclui }}
                    refresh={refresh}
                  />
                </Paper>
              </Grid>
            )}

            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default memo(Edicao, isEqual)
